import { render, staticRenderFns } from "./SummaryDashboard.vue?vue&type=template&id=4ebf10d8&scoped=true"
import script from "./SummaryDashboard.vue?vue&type=script&lang=ts"
export * from "./SummaryDashboard.vue?vue&type=script&lang=ts"
import style0 from "./SummaryDashboard.vue?vue&type=style&index=0&id=4ebf10d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebf10d8",
  null
  
)

export default component.exports